import { isPreviewMode } from '../../utils/previewMode';
import { makeGenericApiAction } from './shared/helpers';

const buildMonthDates = (month) => {
  const [year, monthStr] = month.split('-');
  const daysInMonth = new Date(parseInt(year, 10), parseInt(monthStr, 10), 0).getDate();
  return Array.from({ length: daysInMonth }, (_, i) => {
    const day = String(i + 1).padStart(2, '0');
    return `${year}-${monthStr.padStart(2, '0')}-${day}`;
  });
};

/**
 * Find which days are available
 * @returns
 */
export const fetchMonthlyAvailabilitiesAction = (month) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({
      type: 'FETCH_MONTHLY_AVAILABILITIES_SUCCESS',
      payload: { data: { allAvailableDates: buildMonthDates(month) } },
    });
    return;
  }

  makeGenericApiAction({
    action: 'FETCH_MONTHLY_AVAILABILITIES',
    model: 'fetchMonthlyAvailabilities',
    errorMessage: 'an error occurred while retrieving monthly availability.',
    dispatch,
    method: 'get',
    path: `bookings/getAvailabilityAPI?limitToMonthYear=${month}`,
  });
};
